/* eslint-disable import/prefer-default-export */
import qs from 'qs';
import contentService from '../../services/contentService';
import {
  FETCH_ARTICLES_WISSEN_CLEAN_UP,
  FETCH_ARTICLES_WISSEN_FAILURE,
  FETCH_ARTICLES_WISSEN_REQUEST,
  FETCH_ARTICLES_WISSEN_SUCCESS,
  UPDATE_WISSEN_PAGE_START_PARAM,
} from '../constants/wissenTypes';

const fetchArticlesWissenRequest = () => {
  return {
    type: FETCH_ARTICLES_WISSEN_REQUEST,
  };
};

const fetchArticlesWissenSuccess = (payload) => {
  return {
    type: FETCH_ARTICLES_WISSEN_SUCCESS,
    payload,
  };
};

const fetchArticlesWissenFailure = (error) => {
  return {
    type: FETCH_ARTICLES_WISSEN_FAILURE,
    payload: error,
  };
};

export const fetchArticlesWissenCleanUp = () => {
  return {
    type: FETCH_ARTICLES_WISSEN_CLEAN_UP,
  };
};

export const updateWissenPageStartParam = () => {
  return {
    type: UPDATE_WISSEN_PAGE_START_PARAM,
  };
};

export const fetchArticlesWissen = ({
  categories = [],
  city = undefined,
  start = undefined,
  limit = undefined,
  menu = 'wissen',
  locale = 'de',
} = {}) => {
  return (dispatch) => {
    let categoriesList = [];
    let query = '';
    categoriesList = categories.map((item) => item.id);
    if (categoriesList.length > 0) {
      query = qs.stringify(
        {
          _where: { 'categories.id': categoriesList },
        },
        { encode: false, arrayFormat: 'repeat' }
      );
    }
    const contentsQuery = `sort=publishAt%3Adesc&filters[type][$eq]=article&populate[main_image]=true${
      categoriesList.length > 0 ? `&${query}` : ''
    }${menu ? `&filters[menu][$eq]=${menu}` : ''}${
      city ? `&filters[city][$eq]=${city}` : ''
    }${start ? `&pagination[start]=${start}` : ''}${
      limit ? `&pagination[limit]=${limit}` : ''
    }`;
    dispatch(fetchArticlesWissenRequest);
    contentService
      .getContents(contentsQuery, locale)
      .then((response) => {
        const articles = response.data;
        dispatch(
          fetchArticlesWissenSuccess({
            articles,
            limit,
            start,
          })
        );
      })
      .catch((error) => {
        const errorMsg = error.message;
        dispatch(fetchArticlesWissenFailure(errorMsg));
      });
  };
};
